import styled from 'styled-components';

export const Container = styled.div`
  padding: 2rem;
`;

export const TitlePage = styled.h5`
  color: ${({ theme }) => theme.colors?.text.primary};
`;
